// extracted by mini-css-extract-plugin
export default {"page":"forgotTagId_page__VWtmn"};